export { default as MasterPage } from './MasterPage'
export { default as IndexPage } from './IndexPage'
export { default as LoginPage } from './LoginPage'
export { default as RegistrationPage } from './RegistrationPage'
export { default as SearchPage } from './SearchPage'
export { default as FavoritesPage } from './FavoritesPage'
export { default as PreferencesPage } from './PreferencesPage'
export { default as NotifsPage } from './NotifsPage'
export { default as ProfilePage } from './ProfilePage'



// WEBPACK FOOTER //
// ./src/pages/index.js